import { render, staticRenderFns } from "./LoginRequest.vue?vue&type=template&id=2f2e47c0&"
import script from "./LoginRequest.vue?vue&type=script&lang=ts&"
export * from "./LoginRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports